import BottleImage from "../../../assets/images/MedicationBottle.png";
import {
  FREQUENCY_MAPPING,
  DELIVERY_TYPE_MAPPING,
} from "./SubscriptionMappings";

const SubscriptionsIndexDesktop = ({
  title = "name",
  className = "",
  subscription = {},
  mailToLink,
}) => {
  return (
    <div
      className={`flex justify-start items-center py-4 border-b border-[#C4BCFF] ${className}`}
    >
      <img src={BottleImage} alt={title} />
      <div className="flex-1 flex flex-wrap gap-2">
        <div className="title flex flex-col gap-2  font-medium text-[14px] min-w-[150px] flex-1 items-start px-6">
          <span className="text-[#5144B4] text-start">Subscription Name</span>
          <span className="font-medium">
            {`${subscription.treatment_name} ${subscription.name}`}
          </span>
        </div>
        <div className="price flex flex-col gap-2 font-medium text-[14px] min-w-[150px] flex-1 items-start  px-6">
          <span className="text-[#5144B4] ">Price</span>
          <span className="font-medium">$ {subscription.price}</span>
        </div>
        <div className="price flex flex-col gap-2 font-medium text-[14px] min-w-[150px] flex-1 items-start  px-6">
          <span className="text-[#5144B4] ">Frequency</span>
          <span className="font-medium">
            {FREQUENCY_MAPPING[subscription.frequency]}
          </span>
        </div>
        <div className="price flex flex-col gap-2 font-medium text-[14px] min-w-[150px] flex-1 items-start  px-6">
          <span className="text-[#5144B4] ">Delivery Type</span>
          <span className="font-medium">
            {DELIVERY_TYPE_MAPPING[subscription.delivery_type]}
          </span>
        </div>
        <div className="price flex flex-col gap-2 font-medium text-[14px] min-w-[150px] flex-1 items-start  px-6">
          <span className="text-[#5144B4] ">Change</span>
          <a
            href={mailToLink}
            className="font-medium text-blue-400 hover:text-lavenderBlue underline"
          >
            Email Us
          </a>
        </div>
      </div>
    </div>
  );
};
export default SubscriptionsIndexDesktop;
